let navGeneration = 0;

export function beginNavigation(): number {
    return ++navGeneration;
}

export function isNavigationStale(gen: number): boolean {
    return gen !== navGeneration;
}
